export const GET_VIDEO_ASSET_ROW_NUMBER_BEGIN = "GET_VIDEO_ASSET_ROW_NUMBER_BEGIN";
export const GET_VIDEO_ASSET_ROW_NUMBER_SUCCESS = "GET_VIDEO_ASSET_ROW_NUMBER_SUCCESS";
export const GET_VIDEO_ASSET_ROW_NUMBER_FAILURE = "GET_VIDEO_ASSET_ROW_NUMBER_FAILURE";

export const INSERT_VIDEO_ASSET_BEGIN = "INSERT_VIDEO_ASSET_BEGIN";
export const INSERT_VIDEO_ASSET_SUCCESS = "INSERT_VIDEO_ASSET_SUCCESS";
export const INSERT_VIDEO_ASSET_FAILURE = "INSERT_VIDEO_ASSET_FAILURE";
